
import { locker } from "./screenLocker";
// locker.lockScreen(); // NOTE: see class window-is-locked in html tag

export default function () {
  let menuButton = document.getElementById('menuButton');
  if (!menuButton) {
    return;
  }
  let header = document.querySelector('.b-header');
  menuButton.addEventListener('click', function (e) {
      menuButton.classList.toggle('b-burger-menu-button--active');
      if (header.classList.contains('b-header--burgered')) {
        setTimeout(() => {
          locker.unlockScreen();
        }, 350);
      } else {
        locker.lockScreen();
      }
      header.classList.toggle('b-header--burgered');
      e.preventDefault();
  });
}